import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Constants, transmissionNotesErrorMap, transmissionNotesErrorMapIso } from '../../../shared/utilities/Constants';
import { firstCharacterAlphaNumeric } from '../../../shared/utilities/FormValidators';
import { wireTransmissionNotesAllowedChars } from '../../../shared/utilities/regex-patterns';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { FeatureFlagService } from 'projects/money-movement-ui/src/app/shared/services/feature-flag-service';
import { createControl } from '../../utilities/formUtilities';
import { selectUseStandingAuth, selectWireInfo } from '../../reducers';
import { selectStandingAuthWireInfo } from '../../../standing-authorizations/reducers';

@Component({
  standalone: false,
  selector: 'mm-wire-transmission-notes',
  templateUrl: './wire-transmission-notes.component.html',
  styleUrls: ['./wire-transmission-notes.component.scss']
})
export class WireTransmissionNotesComponent implements OnInit, OnDestroy {
  @Input() parentForm!: UntypedFormGroup;
  @Input() canDisplayCreditToInfo: boolean;
  @Input() useSloa: boolean;
  @Input() isFromCreateTransaction: boolean;
  transmissionNotesTooltipContent: string = Constants.wireTransmissionNotes;
  irsAbaTransmissionNotesTooltipContent: string = Constants.irsAbaWireTransmissionNotes;
  warningDescription: string = Constants.optionalWireDetailsBannerDescription;
  enableInterimIsoWires: boolean;
  textAreaValue = '';
  destroy$: Subject<boolean> = new Subject();
  controlName: string = "transmissionNotes";
  useSloa$: Observable<boolean>;
  isISOCompliant: boolean;
  isIrsAba: boolean;

  constructor(private store: Store, private ffs: FeatureFlagService, private fb: UntypedFormBuilder) { }

  ngOnInit(): void {
    this.isISOCompliant = this.parentForm?.value?.isISOCompliant;
    createControl(this.parentForm, this.controlName, '', [Validators.pattern(wireTransmissionNotesAllowedChars), Validators.maxLength(Number(this.maxLength))]);

     if(this.isFromCreateTransaction){
        this.store.select(selectWireInfo).pipe(takeUntil(this.destroy$)).subscribe(wireInfo => {
        this.isIrsAba = wireInfo.isIrsAba;
        });
      }
      else{
         this.store.select(selectStandingAuthWireInfo).pipe(takeUntil(this.destroy$)).subscribe(wireInfo => {
         this.isIrsAba = wireInfo.isIrsAba;
       });
      }
  }

  ngOnDestroy(): void {
    this.parentForm?.removeControl(this.controlName);
  }

  get transmissionNotes(): UntypedFormControl | undefined {
    this.textAreaValue = this.parentForm?.get(this.controlName)?.value;
    return this.parentForm.get(this.controlName) as UntypedFormControl;
  }

  get transmissionNotesValidationErrorIso() {
    if (this.transmissionNotes && this.transmissionNotes.errors) {
      const errorKeys: string[] = Object.keys(this.transmissionNotes.errors ?? {});
      if (errorKeys.length > 0) {
        return transmissionNotesErrorMapIso[errorKeys[0] as keyof typeof transmissionNotesErrorMapIso];
      }
    }
  }
  
  get maxLength() {
    if (this.isIrsAba) {
      return Constants.transmissionNotesTaxRemittanceLimit;
    }
    else {
      return Constants.transmissionNotesCharLimit;
    }
  }

  trimWhiteSpace() {
    this.textAreaValue = this.textAreaValue.trim();
  }

  limitLines(event: Event, maxLines: number) {
    let text = (event.target as HTMLTextAreaElement).value;
    if (text.length > 0) {
      const lineCount = 1 + text.replace(/[^\n]/g, '').length;
      if (lineCount > maxLines) {
        const textArray = text.split('\n');
        const newText = textArray.reduce((result, line, lineNum) => {
          if (lineNum < maxLines) {
            return result.concat('\n').concat(line);
          }
          return result.concat(line);
        });
        (event.target as HTMLTextAreaElement).value = newText;
      }
    }
  }

  get hasError(): boolean {
    return (this.transmissionNotes?.touched && this.transmissionNotes?.invalid) ?? false;
  }

}
